<template>
  <v-snackbar
    v-model="snackbar.active"
    :color="snackbar.color"
    :multi-line="multiline"
    :timeout="timeout"
    :right="true"
    :bottom="true"
  >
    <span class="subtitle-1"> {{ snackbar.text }}</span>
    <v-btn dark text @click="close(snackbar.id)">
      {{ $t("components.general.snackbar.close") }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import {
  SNACKBAR_CLOSE,
  SNACKBAR_GLOBAL_NOTIFICATIONS,
  SNACKBAR_RESOLVE_GLOBAL_NOTIFICATION,
} from "@/store/actions/snackbar";
export default {
  props: ["snackbar"],
  data: () => ({}),
  computed: {
    multiline() {
      return this.snackbar.multiLine ? this.snackbar.multiLine : false;
    },
    timeout() {
      return this.snackbar.timeout !== 4000 ? this.snackbar.timeout : 4000;
    },
  },
  watch: {
    //NOTE: In case of snackbar closing with the timeout set
    "snackbar.active": function (newVal, oldVal) {
      if (!newVal) {
        this.$store.commit(SNACKBAR_CLOSE, this.snackbar.id);
      }
    },
  },
  methods: {
    close(id) {
      if (Object.keys(this.snackbar.globalNotifications).length !== 0) {
        this.$store.dispatch(
          SNACKBAR_RESOLVE_GLOBAL_NOTIFICATION,
          this.snackbar.globalNotifications.id
        );
        this.$store.dispatch(
          SNACKBAR_GLOBAL_NOTIFICATIONS,
          this.snackbar.globalNotifications.payload
        );
      } else {
        this.$store.commit(SNACKBAR_CLOSE, id);
      }
    },
  },
};
</script>

<style></style>
